// Newsletter

var $ = jQuery;
var agreement_read = 0;

jQuery(document).ready(function() {
    $('.subscribe-blog-form button[type="submit"]').click(function(e) {
        e.preventDefault();

        var button = $(this);
        var email = $('.subscribe-blog-form input[name="email"]');
        var data = {
            action: 'certistar_subscribe',
            email: email.val(),
        };

        button.prop('disabled', true);
        email.prop('disabled', true);
        $('.subscribe-blog-form .error').hide();
        $('.subscribe-blog-form .error').html('');
        $.post(ajax_object.ajax_url, data, function(response) {
            if(!response.success) {
                $('.subscribe-blog-form .error').html(response.data.message);
                $('.subscribe-blog-form .error').show();
            }
            else {
                $('.subscribe-blog-form .title').hide();
                $('.subscribe-blog-form .confirm').removeClass('hidden');
                email.hide();
                button.hide();
                if(typeof gtag === 'function') {
                    gtag('event', 'Subscribed', { 'event_category': 'Newsletter' });
                }
            }
            button.removeProp('disabled');
            email.removeProp('disabled');
        });
    });

    $('.trial-request-form input[type="submit"]').click(function(e) {
        e.preventDefault();

        var button = $(this);
        var form = $('.trial-request-form');
        var data = {
            action: 'certistar_subscribe_trial',
            email: form.find('input[name="email"]').val(),
            phone: form.find('input[name="phone"]').val(),
            name: form.find('input[name="name"]').val(),
            business: form.find('input[name="business"]').val(),
            locations: form.find('input[name="locations"]').val(),
            zip: form.find('input[name="zip"]').val(),
        };

        button.prop('disabled', true);
        form.find('input').prop('disabled', true);
        form.find('.error').hide().html('');
        $.post(ajax_object.ajax_url, data, function(response) {
            if(!response.success) {
                form.find('.error').html(response.data.message);
                form.find('.error').show();
            }
            else {
                form.hide();
                form.parent().find('.section-header').addClass('hidden');
                form.parent().find('.section-header.confirm').removeClass('hidden');
                $('html, body').animate({
                    scrollTop: $('.section-trial-request').offset().top,
                });
            }
            button.removeProp('disabled');
            form.find('input').removeProp('disabled');
        });
    });

    $('a.agreement-link').click(function() {
        agreement_read = 1;
    });

    $('.beta-signup-form input[type="submit"]').click(function(e) {
        e.preventDefault();

        var button = $(this);
        var form = $('.beta-signup-form');
        var data = {
            action: 'certistar_beta_signup',
            email: form.find('input[name="email"]').val(),
            phone: form.find('input[name="phone"]').val(),
            name: form.find('input[name="name"]').val(),
            business: form.find('input[name="business"]').val(),
            locations: form.find('input[name="locations"]').val(),
            zip: form.find('input[name="zip"]').val(),
            version: form.find('input[name="version"]').val(),
            agreement: form.find('input[name="agreement"]:checked').val(),
            agreement_read: agreement_read,
        };

        button.prop('disabled', true);
        form.find('input').prop('disabled', true);
        form.find('.error').hide().html('');
        $.post(ajax_object.ajax_url, data, function(response) {
            if(!response.success) {
                form.find('.error').html(response.data.message);
                form.find('.error').show();
            }
            else {
                form.hide();
                form.parent().find('.section-header').addClass('hidden');
                form.parent().find('.section-header.confirm').removeClass('hidden');
                $('html, body').animate({
                    scrollTop: $('.section-beta-signup').offset().top,
                });
            }
            button.removeProp('disabled');
            form.find('input').removeProp('disabled');
        });
    });

    $('.registration-form input[type="submit"]').click(function(e) {
        e.preventDefault();

        var button = $(this);
        var form = $('.registration-form');
        var data = {
            action: 'certistar_trial_signup',
            email: form.find('input[name="email"]').val(),
            phone: form.find('input[name="phone"]').val(),
            first_name: form.find('input[name="first_name"]').val(),
            last_name: form.find('input[name="last_name"]').val(),
            title: form.find('input[name="title"]').val(),
            company_name: form.find('input[name="company_name"]').val(),
            zip: form.find('input[name="zip"]').val(),
            version: form.find('input[name="version"]').val(),
            agreement: form.find('input[name="agreement"]:checked').val(),
            agreement_read: 1,
        };

        button.prop('disabled', true);
        form.find('input').prop('disabled', true);
        form.find('.error').hide().html('');
        $.ajax({
            method: 'POST',
            url: ajax_object.ajax_url,
            data: {
                action: 'validate_form',
                recaptcha_response: form.find('textarea[name="g-recaptcha-response"]').val(),
            },
        }).fail(function() {
            form.find('.error').html('reCAPTCHA verification failed');
            form.find('.error').show();
            $('html, body').animate({
                scrollTop: $('.section-registration').offset().top,
            });
            button.removeProp('disabled');
            form.find('input').removeProp('disabled');
        }).success(function() {
            $.ajax({
                method: 'POST',
                url: ajax_object.certistar_api_url + '/register',
                data: data,
                beforeSend: function(xhr) {
                    xhr.setRequestHeader('Accept', 'application/json');
                },
            }).done(function() {
                form.hide();
                form.parent().find('.section-header').addClass('hidden');
                form.parent().find('.section-header.confirm').removeClass('hidden');
                $('html, body').animate({
                    scrollTop: $('.section-registration').offset().top,
                });
                if(typeof gtag === 'function') {
                    gtag('event', 'Submitted', { 'event_category': 'Registration Form' });
                }
            }).fail(function(response) {
                var res = response.responseJSON.errors || {};
                var errors = [];
                Object.keys(res).forEach(function(key) {
                    errors.push(res[key]);
                });
                form.find('.error').html(errors.join('<br>'));
                form.find('.error').show();
                $('html, body').animate({
                    scrollTop: $('.section-registration').offset().top,
                });
                grecaptcha.reset();
            }).always(function() {
                button.removeProp('disabled');
                form.find('input').removeProp('disabled');
            });
        });
    });

    $('.registration-form-schools input[type="submit"]').click(function(e) {
        e.preventDefault();

        var button = $(this);
        var form = $('.registration-form-schools');
        var data = {
            action: 'certistar_schools_signup',
            email: form.find('input[name="email"]').val(),
            phone: form.find('input[name="phone"]').val(),
            first_name: form.find('input[name="first_name"]').val(),
            last_name: form.find('input[name="last_name"]').val(),
            title: form.find('input[name="title"]').val(),
            company_name: form.find('input[name="company_name"]').val(),
            zip: form.find('input[name="zip"]').val(),
            version: form.find('input[name="version"]').val(),
            platform: form.find('input[name="platform"]:checked').val(),
            agreement: form.find('input[name="agreement"]:checked').val(),
            agreement_read: 1,
        };

        if (!data.platform) {
            form.find('.error').html('Please select a platform you are interested in');
            form.find('.error').show();
            $('html, body').animate({
                scrollTop: $('.section-registration').offset().top,
            });
            return;
        }

        button.prop('disabled', true);
        form.find('input').prop('disabled', true);
        form.find('.error').hide().html('');

        if (data.platform === 'restaurants') {
            $.ajax({
                method: 'POST',
                url: ajax_object.ajax_url,
                data: {
                    action: 'validate_form',
                    recaptcha_response: form.find('textarea[name="g-recaptcha-response"]').val(),
                },
            }).fail(function() {
                form.find('.error').html('reCAPTCHA verification failed');
                form.find('.error').show();
                $('html, body').animate({
                    scrollTop: $('.section-registration').offset().top,
                });
                button.removeProp('disabled');
                form.find('input').removeProp('disabled');
            }).success(function() {
                $.ajax({
                    method: 'POST',
                    url: ajax_object.certistar_api_url + '/register',
                    data: data,
                    beforeSend: function(xhr) {
                        xhr.setRequestHeader('Accept', 'application/json');
                    },
                }).done(function() {
                    form.hide();
                    form.parent().find('.section-header').addClass('hidden');
                    form.parent().find('.section-header.confirm').removeClass('hidden');
                    $('html, body').animate({
                        scrollTop: $('.section-registration').offset().top,
                    });
                    if(typeof gtag === 'function') {
                        gtag('event', 'Submitted', { 'event_category': 'Registration Form' });
                    }
                }).fail(function(response) {
                    var res = response.responseJSON.errors || {};
                    var errors = [];
                    Object.keys(res).forEach(function(key) {
                        errors.push(res[key]);
                    });
                    form.find('.error').html(errors.join('<br>'));
                    form.find('.error').show();
                    $('html, body').animate({
                        scrollTop: $('.section-registration').offset().top,
                    });
                    grecaptcha.reset();
                }).always(function() {
                    button.removeProp('disabled');
                    form.find('input').removeProp('disabled');
                });
            });
        }

        if (data.platform === 'schools') {
            $.ajax({
                method: 'POST',
                url: ajax_object.ajax_url,
                data: {
                    action: 'validate_form',
                    recaptcha_response: form.find('textarea[name="g-recaptcha-response"]').val(),
                },
            }).fail(function() {
                form.find('.error').html('reCAPTCHA verification failed');
                form.find('.error').show();
                $('html, body').animate({
                    scrollTop: $('.section-registration').offset().top,
                });
                button.removeProp('disabled');
                form.find('input').removeProp('disabled');
            }).success(function() {
                $.ajax({
                    method: 'POST',
                    url: ajax_object.ajax_url,
                    data: data,
                }).done(function() {
                    form.hide();
                    form.parent().find('.section-header').addClass('hidden');
                    form.parent().find('.section-header.confirm').removeClass('hidden');
                    $('html, body').animate({
                        scrollTop: $('.section-registration').offset().top,
                    });
                    if(typeof gtag === 'function') {
                        gtag('event', 'Submitted', { 'event_category': 'Registration Form Schools' });
                    }
                }).fail(function(response) {
                    console.log(response);
                    var res = response.responseJSON.data.errors || [];
                    var errors = [];
                    res.forEach(function(error) {
                        errors.push(error);
                    });
                    form.find('.error').html(errors.join('<br>'));
                    form.find('.error').show();
                    $('html, body').animate({
                        scrollTop: $('.section-registration').offset().top,
                    });
                    grecaptcha.reset();
                }).always(function() {
                    button.removeProp('disabled');
                    form.find('input').removeProp('disabled');
                });
            });
        }
    });
});



// WEBPACK FOOTER //
// ./src/js/newsletter.js